import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TextPlugin } from 'gsap/TextPlugin';
import { gsap } from 'gsap';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TextPlugin);

export default gsap;
